// @ts-nocheck

import CommonApi from './../commonApi';
const convertDataToServer = businessCalendarForBudget => ({
  ...businessCalendarForBudget,
  month: businessCalendarForBudget.month + 1
});
const convertDataFromServer = businessCalendarForBudget => ({
  ...businessCalendarForBudget,
  month: businessCalendarForBudget.month - 1
});
const businessCalendarForBudget = new CommonApi('productionCalendarForBudget', 'Производственный календарь для бюджета НТС', convertDataToServer, convertDataFromServer);
export default {
  ...businessCalendarForBudget
};
